import { z } from 'zod';

export const motLookupSchema = z
  .object({
    vin: z.string().min(11).max(17).optional().or(z.literal('')),
    vrm: z.string().min(1).max(10).optional().or(z.literal('')),
  })
  .refine((d) => Boolean(d.vin || d.vrm), { message: 'Enter a VIN or VRM', path: ['vrm'] });

export type MotLookupFormInputs = z.infer<typeof motLookupSchema>;
